import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from "react-router-dom";



export const FeedbackPanel = () => {
    const [FeedbackData, setFeedbackData] = useState([]);
    const navigate = useNavigate();


    useEffect(() => {
    const fetchPoints = async () => {
      const response = await axios.get(
        "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/feedback_list"
      );
      setFeedbackData(response.data.data);
    };

    fetchPoints();
  }, []);

   const handleDelete = async (userId) => {
    try {
      const response = await axios.post(
        "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/delete_feedback",
        { feed_id: userId },
      );

      if (response.data.success === "1") {
        setFeedbackData((prevUser) =>
          prevUser.filter((user) => user.feed_id !== userId)
        );
        toast.error(response.data.message || "Data Deleted Successfully!");
        navigate("/Feedback");
      } else {
        toast.error(response.data.error || "Delete failed.");
      }
    } catch (error) {
      console.error("There was an error!", error);
      toast.error("Failed to delete Attribute.");
    }
  };

    return (
        <div className="container mt-5">
      <table className="table table-bordered table-striped">
        <thead className="">
          <tr >
            <th colSpan="9" className=" text-center bg-white fs-4 text-black">Feedback Table</th>
          </tr>
          <tr>
            <th className="text-white text-center table-custom">Full Name</th>
            <th className="text-white text-center table-custom">Phone Number</th>
            <th className="text-white text-center table-custom">Reception</th>
            <th className="text-white text-center table-custom">Room Cleanliness</th>
            <th className="text-white text-center table-custom">Food Quality</th>
            <th className="text-white text-center table-custom">Staff Behavior</th>
            <th className="text-white text-center table-custom">Quality Service</th>
            <th className="text-white text-center table-custom">Suggestion</th>
            <th className="text-white text-center table-custom">Actions</th>
          </tr>
        </thead>
        <tbody>
          {FeedbackData.map((feed, index) => (
            <tr key={index}>
              <td className="text-center">{feed.full_name}</td>
              <td className="text-center">{feed.phone_number}</td>
              <td className="text-center">{feed.reception}</td>
              <td className="text-center">{feed.room_cleanliness}</td>
              <td className="text-center">{feed.food_quality}</td>
              <td className="text-center">{feed.staff_behavior}</td>
              <td className="text-center">{feed.quality_service}</td>
              <td className="text-center">{feed.suggestion}</td>
              <td className="text-center">
                <button 
                    className="btn btn-danger btn-sm me-1"
                    onClick={() => handleDelete(feed.feed_id)}
                  >
                    <i class="fa-regular fa-trash-can text-white"></i>
                  </button>                
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>    
    );
};
